import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
import "../../App.scss";
import "./FAQ.css";
// import YouTube from "react-youtube";
import axios from "axios";
// import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import { purple } from "@material-ui/core/colors";
import { withStyles } from "@material-ui/core/styles";
import PandaVideoImage from "../../assets/panda.png";
import psLogo from "../../assets/psLogo.png";
// import cafe from "../../assets/help/cafe.png";
// import coffee from "../../assets/help/coffee.png";
// import courses from "../../assets/help/courses.png";
// import cycle from "../../assets/help/cycle.png";
// import pit from "../../assets/help/pit.png";
// import procrastination from "../../assets/help/procrastination.png";
import hangout from "../../assets/faq_illustrations/hangout.png";
import organized from "../../assets/faq_illustrations/organized.png";
// import pyramidOld from "../../assets/help/pyramid.png";
import pyramid from "../../assets/help/pyramid2.bmp";
// import silent from "../../assets/help/silent.jpeg";
import ModalVideo from "react-modal-video";
import demoVideo from "../../assets/demoVideo.png";
// import finboy from "../../assets/course_specific/finboy.png"
import jsframe from "../../assets/course_specific/jsframeworks.png"
import math from "../../assets/course_specific/math.png"
import pie from "../../assets/course_specific/pie.png"
import robot from "../../assets/course_specific/robot.png"
import rocket from "../../assets/course_specific/rocket.png"
import teachbar from "../../assets/course_specific/teachbar.png"



// import "node_modules/react-modal-video/scss/modal-video.scss";

const FAQ = () => {

  // const EmailTextField = withStyles(() => ({
  //   root: {
  //     background: "#FFFFFF",
  //     marginRight: "0.8em",
  //     width: "20em",
  //   },
  // }))(TextField);
  // <img alt="todo list" src={todo} className="featureImage"></img>

  const [navBarPos, setNavBarPos] = useState("navBarTop");
    const [isOpenVideo, setOpenVideo] = useState(false);
  // const [value, setValue] = useState(""); // email input, change in the future
    // const [emailWarning, setEmailWarning] = useState("");

      useEffect(() => {
        if (
          window.location.protocol === "http:" &&
        window.location.hostname !== "localhost"
        ) {
        window.location.href = window.location.href.replace("http:", "https:");
      } else {
        axios.post("/api/metrics/landingPage");
      }

      document.addEventListener("scroll", (e) => {
        let scrolled = document.scrollingElement.scrollTop;
        if (scrolled >= 100) {
          setNavBarPos("navBarMoved");
        // console.log("moved");
      } else {
        setNavBarPos("navBarTop");
        // console.log("top");
      }
    });
  }, []);



  return (
  <div className="faq">
{/* NAVBAR */}
<div className={`navBar primary-color ${navBarPos}`}>
<div className="homeLogo">
<h2>
<a href="#homeWrap">
<img alt="pairstudy logo" className="logo" src={psLogo}></img>
PairStudy{" "}
</a>{" "}
</h2>
</div>
<div className="menu">
<h2>
<a href="https://pairstudy.com/#features">Features </a>
</h2>
<h2>
<a href="https://pairstudy.com/#section2">Demo </a>
</h2>
<h2>
<a href="https://pairstudy.com/#section3">About </a>
</h2>
<h2>
<a href="https://pairstudy.com/#section4">Contact </a>
</h2>
</div>
<div className="loginWrap">
<button className="loginButton">
{" "}
{process.env.NODE_ENV === "development" ? (
  <a href="/home">Login </a>
  ) : (
  <a href="https://www.pairstudy.com/home">Login </a>
  )}
            {/* <Link to="/home">
              {" "}
              <div className="landingButton">Login </div>
            </Link> */}
            </button>
            </div>
            </div>
          {/* NAVBAR END*/}

          <div id="homeWrap" className="blockWrap primary-color">
          <div id="homeMiddleWrap">
          <div className="faqWrap">

          <h1>FAQs </h1>
          </div>

          </div>
          <div id="homeRightWrap">
          <img
          alt="panda in a video cam"
          id="pandaImage"
          src={PandaVideoImage}
          onClick={() => setOpenVideo(true)}
          ></img>
          <div className="socialMedia">
          <a
          target="_blank"
          without="true"
          rel="noopener noreferrer"
          href="https://www.instagram.com/pairstudy_/"
          >
          <svg
          id="instagamIcon"
          width="35"
          height="35"
          viewBox="0 0 46 46"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          >
          <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M3.83325 11.5002C3.83325 9.46684 4.64099 7.51679 6.07877 6.07901C7.51655 4.64123 9.46659 3.8335 11.4999 3.8335H34.4999C36.5332 3.8335 38.4833 4.64123 39.9211 6.07901C41.3589 7.51679 42.1666 9.46684 42.1666 11.5002V34.5002C42.1666 36.5335 41.3589 38.4835 39.9211 39.9213C38.4833 41.3591 36.5332 42.1668 34.4999 42.1668H11.4999C9.46659 42.1668 7.51655 41.3591 6.07877 39.9213C4.64099 38.4835 3.83325 36.5335 3.83325 34.5002V11.5002ZM11.4999 7.66683C10.4833 7.66683 9.50823 8.0707 8.78934 8.78959C8.07045 9.50848 7.66659 10.4835 7.66659 11.5002V34.5002C7.66659 35.5168 8.07045 36.4919 8.78934 37.2107C9.50823 37.9296 10.4833 38.3335 11.4999 38.3335H34.4999C35.5166 38.3335 36.4916 37.9296 37.2105 37.2107C37.9294 36.4919 38.3333 35.5168 38.3333 34.5002V11.5002C38.3333 10.4835 37.9294 9.50848 37.2105 8.78959C36.4916 8.0707 35.5166 7.66683 34.4999 7.66683H11.4999ZM22.9999 17.2502C21.4749 17.2502 20.0124 17.856 18.9341 18.9343C17.8557 20.0126 17.2499 21.4752 17.2499 23.0002C17.2499 24.5252 17.8557 25.9877 18.9341 27.066C20.0124 28.1444 21.4749 28.7502 22.9999 28.7502C24.5249 28.7502 25.9875 28.1444 27.0658 27.066C28.1441 25.9877 28.7499 24.5252 28.7499 23.0002C28.7499 21.4752 28.1441 20.0126 27.0658 18.9343C25.9875 17.856 24.5249 17.2502 22.9999 17.2502ZM13.4166 23.0002C13.4166 20.4585 14.4263 18.0209 16.2235 16.2237C18.0207 14.4265 20.4583 13.4168 22.9999 13.4168C25.5416 13.4168 27.9791 14.4265 29.7764 16.2237C31.5736 18.0209 32.5833 20.4585 32.5833 23.0002C32.5833 25.5418 31.5736 27.9794 29.7764 29.7766C27.9791 31.5738 25.5416 32.5835 22.9999 32.5835C20.4583 32.5835 18.0207 31.5738 16.2235 29.7766C14.4263 27.9794 13.4166 25.5418 13.4166 23.0002ZM33.5416 15.3335C34.3041 15.3335 35.0354 15.0306 35.5745 14.4914C36.1137 13.9523 36.4166 13.221 36.4166 12.4585C36.4166 11.696 36.1137 10.9647 35.5745 10.4256C35.0354 9.8864 34.3041 9.5835 33.5416 9.5835C32.7791 9.5835 32.0478 9.8864 31.5087 10.4256C30.9695 10.9647 30.6666 11.696 30.6666 12.4585C30.6666 13.221 30.9695 13.9523 31.5087 14.4914C32.0478 15.0306 32.7791 15.3335 33.5416 15.3335Z"
          fill="#AEB4BE"
          />
          </svg>
          </a>
          </div>
          </div>
          </div>




          <div id="section_a" className="blockWrap secondary-color">


          <div class="row">
          <div class="col-md-3"></div>
          <div class="col-md-6"><br/><br/><br/>

          <div className="question">
          <h3>How does Pairstudy help me study?</h3>
          </div>




          <div className="answer">
          <h4>
          Pairstudy is designed to help you get the most out of your study sessions.
          We use science-backed study techniques to help you reach the level of productivity you need for your classes.
          </h4>

          <br/><br/>
          </div></div>
          <div class="col-md-3"></div>
          </div>








          <br/><br/>







          <div id="section_b" className="blockWrap primary-color">


          <div class="container">
          <div class="row">
          <div className="question">
          <h3>What room should I study in?</h3>

          </div>
          <div class="col-md-6 studyModeLeft">
          <div className="" >

          <h3 textAlign="left">Silent Mode </h3>

          <img alt="todo list" src={organized} className="featureImage"></img>
          <p>
          This room is for serious scholars only!
          Everyone will be muted so you can get those
          assignments in before the deadline!
          </p>
          </div>
          </div>

          <div class="col-md-6">
          <h3>Cafe </h3>


          <img alt="todo list" src={hangout} className="featureImage"></img>
          <p>
          Need a break?
          Want to work and chit-chat at the same time?
          Then the Cafe is your room of choice!
          </p>

          </div>

          </div>
          </div>

          <br/>

          <br/>


          <br/>


          <div class="row">
          <div class="col-md-3"></div>
          <div class="col-md-6">
          <div className="">

          <h3>Specialized Course Rooms</h3>
          <p>
          These are courses specific rooms that are there for you to
          work on practice problems and consolidate the knowledge of your classes.
          In these virtual rooms, you can finally get to know your classmates!
          </p>

          <br/>

          <div class="row">
            <div class="col-md-3">
              <img alt="" src={math} className="featureImage"></img>
            </div>

            <div class="col-md-3">
              <img alt="" src={rocket} className="featureImage"></img>
            </div>

            <div class="col-md-3">
              <img alt="" src={teachbar} className="featureImage"></img>
            </div>



          </div>




          {/* <img alt="todo list" src={courses} className="featureImage"></img> */}

          <br/><br/><br/>

          <p>

          </p>

          <h3>You will learn better with PairStudy! </h3>

        <img alt="" src={pyramid} ></img>
          </div>

          <div class="container">

  {/* <img src="pyramid" alt="Norway" style="width:100%;"> */}
  {/* <img alt="" src={pyramid} width="100" ></img> */}
  <div class="text-block">
    {/* <br/>  */}
    <p>As the learning pyramid suggests, the maximum amount of learning
    and retention happens when you actually articulate the contents
    of your subject material.</p>

  </div>
</div>


          </div>
          <div class="col-md-3"></div>
          </div>



          <p><br/> </p>


          </div>

          </div>

          <div id="section_c" className="blockWrap  secondary-color">

          <div class="row">
          <div class="col-md-3"></div>
          <div class="col-md-6">

          <div className="question">
          <h3>
          Who are we?
          </h3>
          </div>

          <div className="answer">
          We are recent graduates of Columbia University
          so we know how hard it is to study alone from home.
          We are here to help you stay motivated and meet people from all
          around the campus while you are in the comfort of your room.
          </div>

          <br/><br/>
          <div className="question">
          <h3>Who should use Pairstudy?</h3>
          </div>

          <div className="answer">
          Any Columbia University student no matter where you are in the world.
          At Pairstudy Columbia University students can find partners and groups
          to study with and have the opportunity to meet interesting people from
          all around the world.
          </div>

          <br/><br/>

          <div className="question">
          <h3>
          Is Pairstudy safe?
          </h3>
          </div>

          <p>Yes! At Pairstudy, safety is our top priority.
            We take several measures to make sure
            our users feel safe and secure.
          </p>

          <h4>University Network</h4>
          We only match you with other students at Columbia University!
          You’re required to use your Columbia Edu email in order to Login.
          This ensures that you are always connected to another verified student.

          <h4>Community Guideline</h4>
          When joining your first study session, you accept the terms of our Community Guideline.
          Our rules and guideline make sure you have a safe study environment and every other member
          of our platform respects you.
          After all, you are here to support each other.


          <h4>Report people</h4>

          If anytime you notice inappropriate behaviour you can report
          the person from the profile page or write an email to hello@pairstudy.com.
          We take every report very seriously, it goes straight to
          our primary inbox so we can act on it immediately.

          </div>
          <div class="col-md-3"></div>
          </div>



          </div>



          <div id="section2" className="blockWrap primary-color">
          <h1> Video </h1>
          <p>A quick walk through of PairStudy </p>

          <ModalVideo
          channel="youtube"
          autoplay
          isOpen={isOpenVideo}
          videoId="9zTWht5TLoA"
          onClose={() => setOpenVideo(false)}
          />
          <img
          id="demoVideo"
          alt="pairstudy video demo, click to listen"
          src={demoVideo}
          onClick={() => setOpenVideo(true)}
          ></img>
          </div>



          <div id="section4" className="blockWrap primary-color">
          <h1>Contact</h1>
          <p> us </p>
          <h3>hello@pairstudy.com</h3>
          <p> We are just an email away </p>
          </div>
          </div>
          );
};

export default FAQ;
